import React from 'react';
import { Camera } from 'lucide-react';

const Landing: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center px-6 bg-gradient-to-b from-gray-50 to-white">
    <div className="max-w-md text-center space-y-5">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white shadow-lg shadow-indigo-200">
        <Camera size={28} />
      </div>
      <h1 className="text-3xl font-bold serif text-gray-900">ReleaseSnap</h1>
      <p className="text-sm text-gray-500 leading-relaxed">
        Photographer? Open the ReleaseSnap Telegram bot to create or manage releases.
      </p>
      <p className="text-xs text-gray-400 leading-relaxed">
        Recipients: please open the signing link you received by email or Telegram.
      </p>
    </div>
  </div>
);

export default Landing;
